import { HR_TIME_OFF_REQUESTS_ROUTE, pageKindLineText, t } from '@bms2/shared';
import { PageModule } from '../../shell/PageModule';
import { TimeOffApprovals } from './TimeOffApprovals';
import styles from './TimeApproval.module.css';

/**
 * Time Off Requests (piece 34; decisions 13030, 13250; T3905): the HR group's own row. 🔒 The same list Time Awaiting
 * Approval draws under its heading, read by the route that answers only the requests this viewer decides, so a manager
 * who holds no `time.approve` reaches it and the day approvals they never had are not drawn.
 */
export function TimeOffRequestsPage({ apiBaseUrl = '' }: { apiBaseUrl?: string }) {
  return (
    <PageModule title={t('hr.timeOffApproval.heading')} subtitle={pageKindLineText({ page: 'named', route: HR_TIME_OFF_REQUESTS_ROUTE })} icon="hr">
      <div className={styles.page} data-page="time-off-requests">
        <TimeOffApprovals apiBaseUrl={apiBaseUrl} />
      </div>
    </PageModule>
  );
}
